/**
 * Landing product catalog helpers for the products grid.
 */

export function isLandingProductActive(product, activeProducts = {}) {
    const isActive = activeProducts[product.id]?.active;
    const isChildOfActive = product.parent && activeProducts[product.parent]?.active;
    return Boolean(isActive || isChildOfActive);
}

export function filterActiveLandingProducts(catalog, activeProducts = {}) {
    return catalog.filter((product) => isLandingProductActive(product, activeProducts));
}

export function getProductsNavClass(productCount) {
    return productCount < 3 ? "few-products" : "many-products";
}
